import {Record as record} from 'immutable';

export default record(
    {
        badges: [],
        byOwnerProperties: {},
        byOwnerPropertiesFetchFailed: false,
        byOwnerPropertiesFetchSuccess: false,
        propertyContentItems: [],
        recommendedProperties: {},
        recommendedPropertiesFetchSuccess: false,
        recommendedPropertiesFetchFailed: false,
        registrationNumber: '',
        unitSpaces: {},
        unitContentItems: [],
        unitMetadata: [],
        urgencyMessage: null,
        houseRules: {},
        discoveryFeed: {},
        rankedBadges: [],
        geoRelativeDistances: null
    },
    'listingExtended'
);
